// extracted by mini-css-extract-plugin
export default {"address":"Address_address__FjajJ","form":"Address_form__aPnp9","flexip":"Address_flexip__LbsIO","flexbtn":"Address_flexbtn__Zz3kW","flexp":"Address_flexp__9TUF8"};